import React, { useState } from "react";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import EditForm from "../../Components/Profile/ProfileEditForm";
import ProfileInformation from "../../Components/Profile/ProfileInformation";

function setData(userData) {
  const name =
    userData.first_name && userData.last_name
      ? `${userData.first_name} ${userData.last_name}`
      : "نامشخص";
  const email = userData.email ? userData.email : "نامشخص";
  const mobileNumber = userData.mobile_number;
  return {
    name,
    email,
    mobileNumber
  };
}

const ProfileComponent = ({ ...props }) => {
  const { edit, setedit, data } = props;
  return edit ? (
    <EditForm setEdit={setedit} />
  ) : (
    <ProfileInformation
      name={data.name}
      email={data.email}
      mobileNumber={data.mobileNumber}
      setEdit={setedit}
    />
  );
};

const Profile = ({ ...props }) => {
  const { userData, isLogin } = props;
  const [edit, setedit] = useState(false);
  const data = setData(userData);
  return (
    <div className="container">
      <InnerHeader isLogin={isLogin} />
      <ProfileComponent edit={edit} setedit={setedit} data={data} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userData: state.auth.userInfo,
    isLogin: state.auth.isLogin
  };
};

export default connect(mapStateToProps)(Profile);
